<script setup lang="ts">
import { useI18n } from '@/plugins/i18n';
import { useSearchStore } from '@/components/Search/store/index.ts';
import FilterDropdown from '@/components/Search/FilterDropdown.ce.vue';
import CategoriesFilter from '@/components/Search/SearchFilters/Common/CategoriesFilter/index.ce.vue';

import iconMyCollections from '@/assets/img/icon-search-all-filters-my-collections.svg';
import iconCompanyCollection from '@/assets/img/icon-search-all-filters-company-collection.svg';
import iconDocumentType from '@/assets/img/icon-search-all-filters-document-type.svg';
import iconStatus from '@/assets/img/icon-search-all-filters-status.svg';
import iconTags from '@/assets/img/icon-search-all-filters-tags.svg';
import { STANDARDS_SEARCH_TAB, COLLECTIONS_SEARCH_TAB } from '@/components/Search/constants.ts';

//store
const searchStore = useSearchStore()

//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance
</script>

<template>
    <div class="all-filters-body">
        <div class="filter-item myCollections">
            <FilterDropdown
            className="accordion"
            :placeholder="t('myCollections')" 
            name="colls[]" 
            :multiple="true" 
            :field="`${COLLECTIONS_SEARCH_TAB}.collections`"
            :lookupField="`lookUpOptions.${COLLECTIONS_SEARCH_TAB}.collections`"
            :hasClear="false" 
            :iconMain="iconMyCollections"
            :iconOpenMain="iconMyCollections"
            :searchable="true"
            :loadOptionsOnClick="true" />
        </div>
        <div class="filter-item companyCollection">
            <FilterDropdown
            className="accordion"
            :placeholder="t('companySets')" 
            name="dcoll" 
            :multiple="false" 
            :field="`${COLLECTIONS_SEARCH_TAB}.companyCollection`"
            :lookupField="`lookUpOptions.${COLLECTIONS_SEARCH_TAB}.companyCollection`"
            :hasClear="false" 
            :iconMain="iconCompanyCollection"
            :iconOpenMain="iconCompanyCollection"
            :searchable="true"
            :loadOptionsOnClick="true" />
        </div>
        <div class="filter-item documentType">
            <FilterDropdown 
            className="accordion"
            :placeholder="t('documentType')" 
            name="type" 
            :multiple="false" 
            :field="`${COLLECTIONS_SEARCH_TAB}.documentType`"
            :lookupField="`lookUpOptions.${COLLECTIONS_SEARCH_TAB}.documentType`"
            :searchable="false"
            :hasClear="false"
            :iconMain="iconDocumentType"
            :iconOpenMain="iconDocumentType"
            />
        </div>  
        <div class="filter-item status">
            <FilterDropdown
            className="accordion"
            :placeholder="t('status')" 
            name="status" 
            :multiple="true" 
            :field="`${COLLECTIONS_SEARCH_TAB}.status`" 
            :lookupField="`lookUpOptions.${STANDARDS_SEARCH_TAB}.status`" 
            :hasClear="false" 
            :iconMain="iconStatus"
            :iconOpenMain="iconStatus"
            :searchable="false" />
        </div>
        <div class="filter-item tag">
            <FilterDropdown
            className="accordion"
            :placeholder="t('tag')" 
            name="tag" 
            :multiple="true" 
            :field="`${COLLECTIONS_SEARCH_TAB}.tags`" 
            :lookupField="`lookUpOptions.${COLLECTIONS_SEARCH_TAB}.tags`" 
            :hasClear="false" 
            :iconMain="iconTags"
            :iconOpenMain="iconTags"
            :searchable="false"
            :loadOptionsOnClick="true" />
        </div>
        <div class="filter-item categories">
            <CategoriesFilter :searchType="COLLECTIONS_SEARCH_TAB" :useTeleport="false"></CategoriesFilter>
        </div>
        <div class="filter-item notes">
            <input type="text" name="notes" :placeholder="t('searchViaNotes')" v-model="searchStore[`${COLLECTIONS_SEARCH_TAB}.notes`]"/>
        </div>
    </div>
</template>